import { parseInstrument } from '../../instrumentUtils';
import type { WidgetDefinition } from '../WidgetDefinition';
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons/faClipboardList';
import type { OrderBlotterWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { OrderBlotterWidgetViewModel } from 'src/store/types';

class OrderBlotterWidgetDefinition implements WidgetDefinition<OrderBlotterWidgetViewModel, OrderBlotterWidgetModel> {
    type = 'order-blotter' as const;
    nameKey = 'widgets::order-blotter::name' as const;
    roles = ['widgets::order-blotter'];
    icon = faClipboardList;
    category = 'widgets::categories::trading' as const;

    /**
     * Converts an OrderBlotter widget from contract model to view model
     */
    toViewModel(widget: OrderBlotterWidgetModel): OrderBlotterWidgetViewModel {
        return {
            ...widget,
            instrument: parseInstrument(''),
        };
    }

    /**
     * Converts an OrderBlotter widget from view model to contract model
     */
    toContractModel(widget: OrderBlotterWidgetViewModel): OrderBlotterWidgetModel {
        const { instrument: _instrument, ...contractWidget } = widget;
        return contractWidget;
    }
}

export const orderBlotterWidgetDefinition = new OrderBlotterWidgetDefinition();
